"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectButtonContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _useToggle = _interopRequireDefault(require("react-use/lib/useToggle"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _SelectButton = require("../SelectButton");
const SelectButtonContainer = _ref => {
  let {
    defaultValue,
    onChange,
    value,
    ...originalProps
  } = _ref;
  const [isOpen, toggleIsOpen] = (0, _useToggle.default)(false);
  const handleChange = value => setStateValue(value);
  const [stateValue, setStateValue] = (0, _reactUseControlledState.default)(defaultValue, value, onChange);
  const addProps = {
    isOpen,
    onChange: handleChange,
    toggleIsOpen,
    value: stateValue
  };
  return /*#__PURE__*/_react.default.createElement(_SelectButton.SelectButton, (0, _extends2.default)({}, originalProps, addProps));
};
exports.SelectButtonContainer = SelectButtonContainer;
//# sourceMappingURL=SelectButtonContainer.js.map